import clsx from 'clsx';
import { PaginationBar } from '@wk/components-v3-react16/pagination-bar';
import {
  OpenPageEvent,
  ResultsPerPageChangeEvent,
} from '@wk/components-v3-react16/pagination-lib';
import styles from './PaginationControls.module.scss';

const AVAILABLE_RESULTS_PER_PAGE = [10, 20, 40];

interface PaginationControlsProperties {
  currentPage: number;
  isFetchingNewPage: boolean;
  isLoading: boolean;
  itemsPerPage: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  onPageChange: (pageNumber: number) => void;
  totalJobs: number;
  totalPages: number;
}

const PaginationControls = ({
  currentPage,
  isFetchingNewPage,
  isLoading,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalJobs,
  totalPages,
}: PaginationControlsProperties) => {
  // Only hide the bar once loading has actually finished and the filters
  // genuinely matched nothing. While the very first fetch is still in
  // flight there is no page-count data yet, but we still want the bar
  // visible (just disabled) instead of popping in once data arrives.
  const hasNoResults = !isLoading && totalJobs === 0;
  if (hasNoResults) {
    return null;
  }

  const isDisabled = isLoading || isFetchingNewPage;

  const handleOpenPage = (event: OpenPageEvent) => {
    onPageChange(event.page);
  };

  const handleResultsPerPageChange = (event: ResultsPerPageChangeEvent) => {
    onItemsPerPageChange(event.resultsPerPage);
  };

  return (
    <div className={clsx(isDisabled && styles.disabled)}>
      <PaginationBar
        availableResultsPerPage={AVAILABLE_RESULTS_PER_PAGE}
        currentPage={currentPage}
        hasTextBar={true}
        onOpenPage={handleOpenPage}
        onResultsPerPageChange={handleResultsPerPageChange}
        pagesCount={totalPages || 1}
        resultsPerPage={itemsPerPage}
        totalResults={totalJobs}
      />
    </div>
  );
};

export default PaginationControls;





